import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DeleteSnoozePayload } from "components";

export const useDeleteInterventionSnoozeMutation = () =>
  useTypedMutation({
    mutationFn: async (payload: DeleteSnoozePayload) => (await ApiInstance.post("/snoozes/delete", payload)).data,
    onSuccess: ({ intervention_id }) => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment?.interventions?.length) return;

      const interventionIdx = appointment.interventions.findIndex(i => i.id === intervention_id);
      if (interventionIdx === -1 || !appointment.interventions[interventionIdx].snooze_history?.length) return;

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, {
        ...appointment,
        interventions: appointment.interventions.with(interventionIdx, { ...appointment.interventions[interventionIdx], snoozed: false, snooze_history: [] })
      });
    }
  });
